import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function SosyalMedyaBagimliligiTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['sosyal-medya-bagimliligi-testi']} />;
}
